import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    } else if (consent === 'accepted') {
      enableAnalytics();
    }
  }, []);

  const enableAnalytics = () => {
    if (window.posthog) {
      window.posthog.opt_in_capturing();
    }
  };

  const disableAnalytics = () => {
    if (window.posthog) {
      window.posthog.opt_out_capturing();
    }
  };

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    enableAnalytics();
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    disableAnalytics();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-up">
      <div className="max-w-2xl mx-auto bg-white border border-[#E4E4E7] rounded-2xl shadow-lg p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1">
            <p className="text-sm text-[#71717A]">
              Vi bruger cookies og analyse til at forbedre din oplevelse.
              Ved at klikke "Acceptér" giver du samtykke til vores brug af cookies til analyse og sessionsoptagelse.{' '}
              <Link to="/privacy" className="text-[#0A0A0A] underline font-medium">
                Privatlivspolitik
              </Link>
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <Button
              variant="outline"
              onClick={handleDecline}
              className="h-10 px-4 rounded-full text-sm"
            >
              Afvis
            </Button>
            <Button
              onClick={handleAccept}
              className="bg-[#0A0A0A] text-white hover:bg-[#0A0A0A]/90 h-10 px-4 rounded-full text-sm font-medium"
            >
              Acceptér
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
